"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _button = _interopRequireDefault(require("../button"));

var _Text = _interopRequireDefault(require("../Text"));

require("./DurationComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RangePicker = _antd.DatePicker.RangePicker;

var DurationComponent = function DurationComponent(_ref) {
  var onChange = _ref.onChange,
      size = _ref.size,
      isSelectDurationVisible = _ref.isSelectDurationVisible,
      cancelBtnName = _ref.cancelBtnName,
      selected = _ref.selected,
      day = _ref.day,
      days = _ref.days,
      cancel = _ref.cancel,
      ranges = _ref.ranges,
      displayCalendar = _ref.displayCalendar,
      applyDuration = _ref.applyDuration,
      applyBtnName = _ref.applyBtnName,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      disabledDate = _ref.disabledDate,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      suffixIcon = _ref.suffixIcon,
      disabled = _ref.disabled;
  var dateFormat = ["YYYY-MM-DD", "YYYY-MM-DD"];
  return /*#__PURE__*/_react["default"].createElement(_antd.Space, {
    direction: "vertical",
    className: className,
    size: size || 12
  }, /*#__PURE__*/_react["default"].createElement(RangePicker, _extends({
    className: "range-picker iiht-range-picker qa-range-picker",
    onOpenChange: function onOpenChange() {
      displayCalendar(isSelectDurationVisible);
    },
    ranges: ranges,
    open: isSelectDurationVisible,
    format: dateFormat,
    onChange: onChange,
    showNow: false,
    renderExtraFooter: function renderExtraFooter() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "duration-footer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "duration-footer-left"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
        className: "qa-footer-btn cancel-duration btn-small",
        type: "secondary",
        onClick: cancel
      }, cancelBtnName)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "duration-footer-right"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "duration-selected"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        className: "body-long-text selected-days-title"
      }, "Selected:"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        className: "body-long-text"
      }, selected === 1 ? "".concat(selected, " ").concat(day) : "".concat(selected, " ").concat(days), " ")), /*#__PURE__*/_react["default"].createElement(_button["default"], {
        className: "qa-footer-btn apply-btn btn-small",
        onClick: applyDuration
      }, applyBtnName)));
    },
    value: value,
    defaultValue: defaultValue,
    disabledDate: disabledDate,
    disabled: disabled
  }, suffixIcon ? {
    suffixIcon: suffixIcon
  } : {}, {
    dropdownClassName: "iiht-range-picker-dropdown",
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    }
  }), function (current) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ant-picker-cell-inner"
    }, current.date());
  }));
};

var _default = DurationComponent;
exports["default"] = _default;